import { GQL_ID } from '@@types'

import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import { ProductsCategoryCarousel } from '@features/products-carousel'

export default function ProductCategoryBlock ({
  payload
}: BlockProps) {
  const categoryId = payload?.id as GQL_ID

  if (!categoryId) {
    return null
  }

  return (
    <ProductsCategoryCarousel categoryId={categoryId} />
  )
}